export { default as CaretIcon } from './component';
